import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";
import { FullHistoryRound, HistoryRound } from "../../commander/Types";

const PAGE_SIZE = 10;
const history = createSlice({
  name: "history",
  initialState: initialState.history,
  reducers: {
    setHistoryLoading(state) {
      return { ...state, loading: true };
    },

    resetHistory(state) {
      return {
        ...state,
        page: 1,
        initialized: false,
        openedRounds: [],
        rounds: {},
      };
    },

    addHistoryRounds(
      state,
      action: PayloadAction<{ rounds: HistoryRound[]; error?: any }>
    ) {
      const newRounds = action.payload.rounds.reduce((acc: any, round) => {
        acc[round.roundId] = {
          loading: true,
          sessionId: "",
          openningBalance: -1,
          views: [],
          ...round,
        };
        return acc;
      }, {});

      const roundsSize = Object.keys(newRounds).length;
      const page =
        // more that one page of history rounds can be added at once
        roundsSize % PAGE_SIZE === 0 && roundsSize !== 0
          ? state.page + roundsSize / PAGE_SIZE
          : -1;

      const error = action.payload.error ?? null;
      const rounds = { ...state.rounds, ...newRounds };
      return {
        ...state,
        initialized: true,
        loading: false,
        rounds,
        error,
        page,
      };
    },

    addHistoryRound(state, action: PayloadAction<FullHistoryRound>) {
      const round = {
        ...state.rounds[action.payload.roundId],
        ...action.payload,
        loading: false,
      };

      const rounds = { ...state.rounds, [action.payload.roundId]: round };

      return { ...state, rounds };
    },
    toggleHistoryRoundVisability(state, action: PayloadAction<string>) {
      const isVisible = state.openedRounds.find((id) => id === action.payload);
      if (!isVisible) {
        const openedRounds = state.openedRounds.concat(action.payload);
        const rounds = { ...state.rounds };

        return { ...state, rounds, openedRounds };
      } else {
        const openedRounds = state.openedRounds.filter(
          (id) => id !== action.payload
        );

        return { ...state, openedRounds };
      }
    },
  },
});

export const {
  setHistoryLoading,
  resetHistory,
  addHistoryRounds,
  addHistoryRound,
  toggleHistoryRoundVisability,
} = history.actions;
export default history;
